let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7p0m8")).then(() => parcelRequire('hqXam'));